/**
 * Utilitário para suprimir avisos específicos do React Router Dom
 * Esta abordagem é uma alternativa para quando há avisos residuais
 * mesmo após a configuração das Future Flags.
 */
import { useEffect } from 'react';

// Lista de avisos específicos do React Router para suprimir
const routerWarningPatterns = [
  /v7_startTransition/,
  /v7_relativeSplatPath/,
  /future flag was merged/,
  /React Router Future Flag Warning/
];

/**
 * Hook para suprimir avisos específicos do React Router
 */
export const useSuppressRouterWarnings = () => {
  useEffect(() => {
    // Salvar a função original de console.warn
    const originalWarn = console.warn;
    
    // Substituir com uma versão filtrada que suprime os avisos do Router
    console.warn = (...args) => {
      // Se o primeiro argumento é uma string e corresponde a um dos padrões a suprimir
      if (
        typeof args[0] === 'string' && 
        routerWarningPatterns.some(pattern => pattern.test(args[0]))
      ) {
        // Ignora este aviso específico
        return;
      }
      
      // Para todos os outros avisos, passa adiante para o warn original
      originalWarn.apply(console, args);
    };
    
    // Restaurar quando o componente for desmontado
    return () => {
      console.warn = originalWarn;
    };
  }, []);
};

/**
 * Componente para suprimir avisos específicos do React Router
 */
export const RouterWarningsSuppressor = ({ children }) => {
  useSuppressRouterWarnings();
  return children;
};
